import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { careerChapters } from '../data/career';
import FloatingIcons from './FloatingIcons';

function Career() {
  return (
    <section className="career-section gray-wave" id="career">
      <FloatingIcons />
      <div className="container">
        <h3 className="section-title">IT Career Chapters</h3>
        <div className="career-grid">
          {careerChapters.map((chapter, index) => (
            <motion.div
              key={chapter.id}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              whileHover={{ y: -10, scale: 1.02 }}
            >
            <Link 
              to={`/career/${chapter.id}`}
              className="career-card"
            >
              <div className="career-thumbnail">
                <img src={chapter.image || chapter.logo} alt={chapter.name} />
                <div className="career-overlay">
                  <img src={chapter.logo} alt={`${chapter.name} logo`} className="career-logo" />
                </div>
              </div>
              <div className="career-content">
                <h4 className="career-name">{chapter.name}</h4>
                <p className="career-title">{chapter.title}</p>
                <p className="career-description">{chapter.content}</p>
              </div>
            </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Career;

